import { Box } from '@mui/material'
import { styled } from '@mui/material/styles'
import type { FC } from 'react'

const ErrorList = styled('ul')(({ theme }) => ({
  paddingLeft: 0,
  marginTop: 4,
  ' > li': {
    listStyleType: 'none',
    color: theme.palette.error.main,
    fontSize: 14
  }
}))

const Errors: FC<{ error: string[] | [] }> = ({ error }) => {
  let errors
  if (Array.isArray(error) && error.length > 0) {
    errors = (
      <ErrorList>
        {error.map((err: string, i: number) => (
          <li key={i}>{err}</li>
        ))}
      </ErrorList>
    )
  }
  return <Box>{errors}</Box>
}

export default Errors
